import { actionCreators } from "../reducers/native";
import { AppDispatch } from "../../index";

export function keyboardOpen(open: boolean) {
    return (dispatch: AppDispatch) => {
        dispatch(actionCreators.keyboardOpen(open));
    };
}
